import { Outlet, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { useState, useEffect } from 'react'
import Sidebar from './Sidebar'
import { Menu } from 'lucide-react'
import { getPageTitle } from '@/lib/pageTitle'

export default function Layout() {
  const location = useLocation()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  // Close sidebar whenever the route changes (nav tap on mobile)
  useEffect(() => {
    setSidebarOpen(false)
  }, [location.pathname])

  const isDashboardRoute = location.pathname.startsWith('/dashboard')

  return (
    <>
      <Helmet>
        <title>redgeGate — SMS &amp; WhatsApp Gateway</title>
        <meta name="description" content="Send SMS and WhatsApp messages from your own devices — one dashboard, one API." />
      </Helmet>

      {isDashboardRoute ? (
        <div className="flex h-screen overflow-hidden bg-background">

          {/* ── Desktop sidebar — always visible on lg+ ── */}
          <div className="hidden lg:flex lg:flex-shrink-0">
            <div className="w-72">
              <Sidebar />
            </div>
          </div>

          {/* ── Mobile sidebar overlay ── */}
          {sidebarOpen && (
            <>
              {/* Backdrop */}
              <div
                className="fixed inset-0 z-40 bg-black/50 lg:hidden"
                onClick={() => setSidebarOpen(false)}
                aria-hidden="true"
              />
              {/* Drawer */}
              <div className="fixed inset-y-0 left-0 z-50 w-72 lg:hidden shadow-xl">
                <Sidebar onClose={() => setSidebarOpen(false)} />
              </div>
            </>
          )}

          {/* ── Main content ── */}
          <div className="flex flex-1 flex-col min-w-0 overflow-hidden">
            {/* Mobile top bar with hamburger */}
            <div className="flex items-center px-4 py-3 border-b border-gray-200 bg-white lg:hidden flex-shrink-0">
              <button
                onClick={() => setSidebarOpen(true)}
                className="p-1.5 rounded-md text-gray-500 hover:bg-gray-100 "
                aria-label="Open navigation menu"
              >
                <Menu className="h-5 w-5" />
              </button>
              <span className="ml-3 text-base font-semibold text-gray-900">{getPageTitle(location.pathname)}</span>
            </div>

            <main className="flex-1 overflow-y-auto bg-background">
              <div className="py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
                <Outlet />
              </div>
            </main>
          </div>
        </div>
      ) : (
        <div className="min-h-screen bg-background">
          <Outlet />
        </div>
      )}
    </>
  )
}
